import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import ApiService from "../../service/httpService.js";
import alertify from "alertifyjs";
const ReimbursementView = ({ Emp_data }) => {
  const [isLoding, setisLoding] = useState(false);
  const [DataSource, setDataSource] = useState([]);
  const Base_URL = process.env.REACT_APP_BASE_URL;
  const [Data, setData] = useState({
    approved_by: "",
    approver: "",
    date_time: "",
    department: "",
    employee: "",
    employee_id: "",
    id: "",
    incharge: "",
    mobile: "",
    total_amount: "",
    reason: "",
    status: "",
  });

  useEffect(() => {
    console.log("Emp_data", Emp_data.id);

    setData({
      approved_by: Emp_data.approved_by,
      approver: Emp_data.approver,
      date_time: Emp_data.date_time,
      department: Emp_data.department,
      employee: Emp_data.employee,
      employee_id: Emp_data.employee_id,
      id: Emp_data.id,
      incharge: Emp_data.incharge,
      mobile: Emp_data.mobile,
      total_amount: Emp_data.total_amount,
      reason: Emp_data.reason,
      status: Emp_data.status,
    });
  }, [Emp_data]);

  console.log("image", isLoding, DataSource);

  // fetching employee datas
  const fetchReimbursementImage = async (id) => {
    setisLoding(true);
    try {
      const res = await ApiService.getPublic(
        `get_data.php?table=reimbursement_image&find=reimbursement_id&value=${id}&authToken=`
      );
      console.log("employee", res);
      setDataSource(res);
      if (res === null || res.length === 0) {
        alertify.error("No Data Found");
      }
    } catch (err) {
      console.log("error on fetchReimbursement", err);
      alertify.error("Error On FetchReimbursement");
    } finally {
      setisLoding(false);
    }
  };

  // This is your effect:
  useEffect(() => {
    console.log(Data?.id);

    if (Data?.id) {
      fetchReimbursementImage(Data?.id);
    }
  }, [Data?.id]);

  function formatDate(dateStr) {
    const date = new Date(dateStr);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12 || 12; // Convert to 12-hour format

    return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
  }

  return (
    <div
      className="modal custom-modal custom-lg-modal fade p-20"
      id="leave-view"
      role="dialog"
    >
      <div className="modal-dialog modal-dialog-centered modal-md">
        <div className="modal-content">
          <div className="modal-header border-0">
            <div className="form-header modal-header-title text-start d-flex align-items-center mb-0">
              <h4 className="mb-0">Reimbursement Details</h4>
            </div>
            <button
              type="button"
              className="btn-close ms-2"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body pb-0">
            <div className="row">
              <div className="col-md-12">
                <div className="form-field-item">
                  <div className="profile-picture company-detail-head">
                    <div className="upload-profile">
                      <div className="add-profile">
                        <p>Status</p>
                      </div>
                    </div>
                    <div>
                      {Data.status === "approved" && (
                        <span className="badge bg-success d-inline-flex align-items-center me-2">
                          <i className="fe fe-check me-1" />
                          {Data.status}
                        </span>
                      )}
                      {Data.status === "Denied" && (
                        <span className="badge bg-danger d-inline-flex align-items-center me-2">
                          <i className="fe fe-check me-1" />
                          {Data.status}
                        </span>
                      )}
                      {Data.status === "applied" && (
                        <span className="badge bg-secondary d-inline-flex align-items-center me-2">
                          <i className="fe fe-check me-1" />
                          {Data.status}
                        </span>
                      )}
                      {Data.status === "Deleted" && (
                        <span className="badge bg-warning d-inline-flex align-items-center me-2">
                          <i className="fe fe-check me-1" />
                          {Data.status}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12">
                <div className="plane-basic-info">
                  <h5>Basic Info</h5>
                  <div className="row">
                    <div className="col-md-4 col-sm-6">
                      <div className="basic-info-detail">
                        <h6>Name</h6>
                        <p>{Data.employee}</p>
                      </div>
                      <div className="basic-info-detail">
                        <h6>Mobile</h6>
                        <p>{Data.mobile}</p>
                      </div>
                      {/* <div className="basic-info-detail">
                                                <h6>User Type</h6>
                                                <p>{Data.user_type}</p>
                                            </div> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12">
                <div className="plane-basic-info plane-detail">
                  <h5>Reimbursement Info</h5>
                  <div className="row">
                    <div className="col-md-4 col-sm-6">
                      <div className="basic-info-detail">
                        <h6>Amount</h6>
                        <p>₹ {Data.total_amount}</p>
                      </div>
                    </div>
                    <div className="col-md-4 col-sm-6">
                      <div className="basic-info-detail">
                        <h6>Apply Date</h6>
                        <p>{formatDate(Data.date_time)}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12">
                <div className="plane-basic-info plane-detail">
                  <div className="basic-info-detail">
                    <h6>Reason</h6>
                    <p>{Data.reason}</p>
                  </div>
                </div>
              </div>
              <div className="row p-3">
                <h5>Attached Images</h5>
                {DataSource &&
                  DataSource.map((item) => (
                    <div
                      key={item.id}
                      className="col-md-4 col-sm-6 mt-3 image-container"
                    >
                      <a
                        className="p-3 border d-block image-container"
                        href={`${Base_URL}${item.path}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={`${Base_URL}${item.path}`}
                          alt="img"
                          className="image"
                        />
                      </a>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ReimbursementView.propTypes = {
  Emp_data: PropTypes.object.isRequired,
};

export default ReimbursementView;
